<div class="browse-container">
  <div class="view-all-categories">
    <ion-button
      data-cy="view-all-categories-button"
      class="usf-green-link-button view-all-categories-button"
      [routerLink]="browseCategoriesPath"
      >{{ 'i18n.search.browsePage.viewAllCategories' | translate }}
    </ion-button>
  </div>
  <div *ngIf="displayGuestTitle" class="guest-banner-title">
    <span
      [ngClass]="
        'guest-browse-explore-text guest-browse-explore-text-' +
        platformService?.platformType
      "
    >
      {{ 'i18n.search.browsePage.guestExplore' | translate }}
    </span>
    <span
      [ngClass]="
        'guest-browse-explore-categories-text guest-browse-explore-categories-text-' +
        platformService?.platformType
      "
    >
      {{ 'i18n.search.browsePage.guestExploreCategories' | translate }}
    </span>
  </div>
  <div
    class="browse-carousel-content"
    [ngClass]="
      (platformService?.isTouchExperience$ | async)
        ? platformService?.platformType ===
          platformService?.platformEnum?.tablet
          ? 'tablet'
          : 'mobile'
        : 'desktop'
    "
  >
    <div *ngIf="!displayGuestTitle" class="banner-title">
      <span class="browse-explore-text">
        {{ 'i18n.search.browsePage.explore' | translate }}
      </span>
      <span class="browse-explore-categories-text">
        {{ 'i18n.search.browsePage.exploreCategories' | translate }}
      </span>
    </div>
    <button
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      class="browse-previous-arrow"
      [ngClass]="
        browseSwiperRef?.swiper.isBeginning ? 'swiper-button-disabled' : ''
      "
      (click)="browseSwiperRef?.swiper.slidePrev()"
    >
      <ion-icon
        slot="icon-only"
        name="arrow-back-circle-outline"
        data-cy="swiper-back-icon"
      ></ion-icon>
    </button>
    <swiper-container
      #browseSwiperRef
      navigation-prev-el=".browse-previous-arrow"
      navigation-next-el=".browse-next-arrow"
      resize-observer="true"
      observer="true"
      slides-per-view="auto"
      space-between="16"
      center-insufficient-slides="false"
      data-cy="card-swiper"
      class="browse-swiper"
      (touchstart)="suppressUntrusted($event)"
    >
      <swiper-slide *ngFor="let category of categories; let index = index">
        <ion-card
          [routerLink]="browseCategoriesPath + '/' + category.classCode"
        >
          <div class="browse-carousel-card-container">
            <img [src]="baseCategoryImageUri + category?.classCode + '.jpg'" />
            <div class="browse-carousel-description">
              <div>{{ category?.classDescription | titlecase }}</div>
            </div>
          </div>
        </ion-card>
      </swiper-slide>
    </swiper-container>
    <button
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      class="browse-next-arrow"
      [ngClass]="browseSwiperRef?.swiper.isEnd ? 'swiper-button-disabled' : ''"
      (click)="browseSwiperRef?.swiper.slideNext()"
    >
      <ion-icon
        slot="icon-only"
        name="arrow-forward-circle-outline"
        data-cy="forward-swiper-icon"
      ></ion-icon>
    </button>
  </div>
</div>
